import { classNames } from '@/shared/lib/classNames/classNames';

interface CasesSectionProps {
  children: React.ReactNode;
  className?: string;
}

export const CasesSection = ({ children, className }: CasesSectionProps) => {
  return (
    <section
      className={classNames({
        cls: 'mx-auto mt-[100px] max-w-[768px] max-lg:px-2 max-sm:mt-16 max-sm:px-0',
        additional: [className],
      })}
    >
      {children}
    </section>
  );
};
